export default __webpack_public_path__ + "static/media/picto-calendar.dc38f4fd.svg";